/* eslint-disable class-methods-use-this */
import sideMessageAPI, {
  ToastMessageEntity,
} from 'utils/__interfaces/SuperAdministration/Message'

class ToastMessagesNormalizer {
  normalize(toastMessages: sideMessageAPI[]): ToastMessageEntity[] {
    return toastMessages.map((message) => {
      return {
        id: message.id,
        messagetext: message.messagetext,
      }
    })
  }
}

export default new ToastMessagesNormalizer()
